function stackGet(key) {
  return this.__data__.get(key);
}
export {
  stackGet as default
};
//# sourceMappingURL=_stackGet.js.map
